import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DefaultFooterComponent } from './default-layout/default-footer/default-footer.component';
import { DefaultHeaderComponent } from './default-layout/default-header/default-header.component';
import { DefaultBodyComponent } from './default-layout/default-body/default-body.component';
import { DefaultSidebarComponent } from './default-layout/default-sidebar/default-sidebar.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from './shared/shared.module';
import { DefaultRightSidebarComponent } from './default-layout/default-right-sidebar/default-right-sidebar.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { originSlashInterceptor } from './services/origin-slash.interceptor';
import { CommonModule, DatePipe } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { MarketTickerComponent } from './default-layout/market-ticker/market-ticker.component';
import { VioTablesModule } from 'vio-tables';
import { VwAppServicesModule } from 'vwappservices';
import { SdcEncryptionService } from './services/sdc-encryption.service';

//const DEV_BASE_URL = 'http://localhost:3028/';
const DEV_BASE_URL = 'https://sdcplus.viotalworks.com/'

const sdcEncryptionService = new SdcEncryptionService();

function loadAppConfig(encryptSvc: SdcEncryptionService): () => Promise<void> {
  return async () => {
    try {
      const base = location.origin.includes('localhost') ? DEV_BASE_URL : `${location.origin}/`;
      const res = await fetch(`${base}common/getappconfig`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({}),
      }).then(r => r.json());
      if (res?.errorCode === '000000') {
        encryptSvc.defaultEncryptionAlgorithm = res.Data?.encryptionAlgo ?? 'NONE';
      }
    } catch {
      // backend unreachable — keep default 'NONE'
    }
  };
}

@NgModule({
  declarations: [
    AppComponent,
    DefaultFooterComponent,
    DefaultHeaderComponent,
    DefaultBodyComponent,
    DefaultSidebarComponent,
    DefaultRightSidebarComponent,
    MarketTickerComponent,
    LoginPageComponent,
  ],
  bootstrap: [AppComponent],
  exports: [NgbDropdownModule],
  imports: [
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    NgbModule,
    NgbDropdownModule,
    CommonModule,
    VioTablesModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      progressAnimation: 'increasing',
    }),
    VwAppServicesModule.forRoot({
      config: {
        baseUrl: location.origin.includes('localhost') ? DEV_BASE_URL : `${location.origin}/`,
        deviceType: 'W',
        authRefreshUrl: 'auth/refresh',
      },
      encryptionService: sdcEncryptionService,
    }),
  ],
  providers: [
    DatePipe,
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([originSlashInterceptor])),
    { provide: SdcEncryptionService, useValue: sdcEncryptionService },
    {
      provide: APP_INITIALIZER,
      useFactory: loadAppConfig,
      deps: [SdcEncryptionService],
      multi: true,
    },
  ],
})
export class AppModule { }
